import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { Form } from '../models';
import { FormState } from '../reducers/form.reducer';

export const selectFormState = createFeatureSelector<FormState>('form');

export const selectFormPageLoading = createSelector(selectFormState, (state) => state.pageLoading);

export const selectFormActionLoading = createSelector(
  selectFormState,
  (state) => state.actionLoading,
);

export const selectFormShowInitWaitingMessage = createSelector(
  selectFormState,
  (state) => state.showInitWaitingMessage,
);

export const selectFormError = createSelector(selectFormState, (state) => state.error);

export const selectFormPage = createSelector(selectFormState, (state) => {
  const forms: Form[] = [];
  each(state.ids, (id: number) => forms.push(state.entities[id]));

  return new QueryResultsModel(forms, state.totalCount);
});
